import { useState } from "react";
import { usePageContext } from "../../../../../hooks/context";
import { useApplicationId } from "../../../../../hooks/useApplicationId";
import {
	useSelectClcPackageMutation,
	useUnSelectClcPackageMutation,
} from "../../../../../services/clc-application";
import { useClcCompanyApplication } from "../../../hooks";

const useClcSelectPackage = () => {
	const applicationId = useApplicationId();
	const { selectedPackage } = usePageContext(useClcCompanyApplication);

	const [selectClcPackage] = useSelectClcPackageMutation();
	const [unSelectClcPackage] = useUnSelectClcPackageMutation();
	const [isSelectingPackage, setIsSelectingPackage] = useState(false);

	const selectPackage = async (packageId: string) => {
		setIsSelectingPackage(true);
		try {
			await unSelectClcPackage(applicationId).unwrap();
			await selectClcPackage({ applicationId, packageId }).unwrap();
		} finally {
			setIsSelectingPackage(false);
		}
	};

	return {
		selectPackage,
		isSelectingPackage,
		selectedPackage,
	};
};

export default useClcSelectPackage;
